import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { CheckCircle, Error, Info } from "@mui/icons-material";
import {
  Card,
  Stack,
  CardHeader,
  AppBar,
  Tabs,
  Tab,
  styled,
  Badge,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import UserDetailsContext from "../../context/auth";
import MaterialBox from "../../components/MaterialBox";
import { useUserDetails } from "../../context/auth";
import { CircularProgress } from "@mui/material";
import { DesignationContext } from "../../context/designationcontext";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -1,
    top: -6,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));
const LeaveManagement = () => {
  const navigate = useNavigate();
  const { handleClearSelection } = useContext(DesignationContext);
  const teamleader = JSON.parse(sessionStorage.getItem("user"));
  const { AccessData, setLeaveShow, HRLIST, SetHRLIST } = useUserDetails();
  const { user, setleavedisplay, setHRRoleLeave, setManagerLeave } =
    useContext(UserDetailsContext);
  const id = user?.id;
  const empid = user?.empid;

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });


  const [tabsOrientation, setTabsOrientation] = useState("horizontal"); //Used to store the orientation of the tabs
  const [tabValue, setTabValue] = useState("Employee"); //Used to store current selected tab
  const [subTabValue, setSubTabValue] = useState(0); //Used to store current selected tab
  //  const[HRRoleLeave,setHRRoleLeave] = useState(false)
  //     const[ManagerLeave,setManagerLeave] = useState(false)
  const [tabs, setTabs] = useState([
    {
      id: "all",
      name: "All",
      count: 1,
    },
    {
      id: "employee",
      name: "Employee",
      count: 0,
    },
    {
      id: "manager",
      name: "Manager",
      count: 2,
    },
  ]); // Used to show tabs name and passing id to database

  const [userDetails, setUserDetails] = useState({
    department: "",
    designation: "",
    employeeType: "",
  });
  const [leaveList, setLeaveList] = useState([]);
  const [managerRequestList, setManagerRequestList] = useState([]);

  // useEffect(() => {
  //   EmployeeLeaveDetails();
  //   ManagerRquestDetails();
  // }, []);

  useEffect(() => {
    getteamleadeID();
  }, []);

  const [TeamLeaderID, setTeamLeaderID] = useState([]);

  const getteamleadeID = async () => {
    const query = `
   query{
  allManagers{
    id
    status
    lastupdate
    user{
      id
      empid
      firstName
      lastName

    }
  }
}
`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const managerList = response.data.data.allManagers;
      const filterdata = managerList.filter(
        (val) => val.user.empid == user.empid
      );
      setTeamLeaderID(filterdata);

      // setManagerList(managerList);
      // setPageState({ ...pageState, loading: false, state: "success" });

    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  useEffect(() => {
    // onManagerDetails();
    // onEmployeeDetails();
    // requesthrlist();
    datahandelar();
  }, [tabValue]);

  const requesthrlist = async () => {
    const query = `query TeamLeaveAll($id: String!) {
    requestsForLeaveTeamAll(id: $id) {
      id
      teamleaderId
      requestedOn
      leaveType{
      leaveType
      }
      leaveFrom
      leaveTill
      totalDays
      halfDay
      reason
      teamApproval
      hrApproval
      status
      user {
        id
        empid
        username
        firstName
      }
    }
  }`;

    const encodedId = btoa(user?.id);
    let data = "VXNlck5vZGU6" + "" + encodedId;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: {
            id: "VXNlck5vZGU6" + "" + encodedId, // Use the encodedId here
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    } catch (error) {
      console.error("errorwwww:", error.response.data);
    }
  };

  const leaveListTable = {
    columns: [
      {
        field: "username",
        headerName: "User Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      // {
      //     field: "requestedOn",
      //     headerName: "Requested On",
      //     flex: 1,
      //     editable: false,
      //     disableColumnMenu: true,
      //     sortable:true,
      // },
      {
        field: "leaveType",
        headerName: "Leave Type",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "leaveFrom",
        headerName: "Leave From",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "leaveTill",
        headerName: "Leave Till",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "totalDays",
        headerName: "Total Days",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "reason",
        headerName: "Reason",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      // ...(AccessData &&
      //   Array.isArray(AccessData) &&
      //   // When ManagerApproval or HRApproval is present and tabValue is Manager or ManagerList
      //   (AccessData.some(
      //     (item) =>
      //       (item.component === "ManagerApproval" ||
      //         item.component === "HrApproval") &&
      //       (tabValue === "Manager" ||
      //         tabValue === "ManagerList" ||
      //         tabValue === "HR" ||
      //         tabValue === "HRList")
      //   ) ||
      //     // When ManagerApproval or HRApproval is not present
      //     !AccessData.some(
      //       (item) =>
      //         item.component === "ManagerApproval" ||
      //         item.component === "HrApproval"
      //     ))
      //     ? [
      //         {
      //           field: "teamApproval",
      //           headerName: "Manager Approval",
      //           flex: 1,
      //           disableColumnMenu: true,
      //           editable: false,
      //           sortable: true,
      //         },
      //       ]
      //     : []),
      {
        field: "teamApproval",
        headerName: "Manager Approval",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "hrApproval",
        headerName: "Hr Approval",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "status",
        headerName: "Status",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: leaveList?.map((leave) => ({
      id: leave.id,
      username: leave.user.firstName
        ? leave.user.firstName?.charAt(0).toUpperCase() +
          leave.user.firstName?.slice(1)
        : "",

      requestedOn: leave.requestedOn,
      leaveType: leave.leaveType?.leaveType
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),

      leaveFrom: leave.leaveFrom,
      leaveTill: leave.leaveTill,
      totalDays: leave.totalDays,
      reason: leave.reason,

      teamApproval: leave.teamApproval
        ? leave.teamApproval?.charAt(0).toUpperCase() +
          leave.teamApproval?.slice(1)
        : "",

      hrApproval: leave.hrApproval
        ? leave.hrApproval?.charAt(0).toUpperCase() + leave.hrApproval?.slice(1)
        : "",
      // status: leave.status,
      status: leave.status
        ? leave.status?.charAt(0).toUpperCase() + leave.status?.slice(1)
        : "",
    })),
  };
  const managerDetails = managerRequestList.map((leave) => ({
    id: leave.id,
    username: leave.user.firstName,
    requestedOn: leave.requestedOn,
    leaveType: leave.leaveType,
    leaveFrom: leave.leaveFrom,
    leaveTill: leave.leaveTill,
    totalDays: leave.totalDays,
    reason: leave.reason,
    teamApproval: leave.teamApproval,
    hrApproval: leave.hrApproval,
    status: leave.status,
  }));

  const EmployeeLeaveDetails = async () => {
    const query = `query leaveTrackDetails($employeeid: String!) {
    leaveRequestsByMe(id: $employeeid) {
      id
      user {
        id
        empid
        username
        firstName
      }
      requestedOn
      leaveType{
        leaveType
      }
      leaveFrom
      leaveTill
      reason
      totalDays
      teamApproval
      hrApproval
      status
    }
  }`;
    const encodedId = btoa(id);
    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,

          variables: { employeeid: "VXNlck5vZGU6" + "" + encodedId },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // Extract department data from the response

      const leaveList = response.data.data.leaveRequestsByMe;

      setLeaveList(leaveList);
      const userDetails = sessionStorage.getItem("user");
      const getDetails = JSON.parse(userDetails);
      // setUserDetails({
      //   department: user?.department || getDetails.department || "",
      //   designation: user?.designation || getDetails.designation || "",
      //   employeeType: user?.employeeType || getDetails.employeeType || "",
      // });
      setPageState({ ...pageState, loading: false, state: "success" });

    } catch (error) {
      // setPageState({ ...pageState, loading: false, error: true, message: error.message });
    }
  };
  const ManagerRquestDetails = async () => {
    const query = `query TeamLeaveRequest($id: String!) {
        requestsForLeaveTeam(id: $id) {
          id
          requestedOn
          leaveType{
          leaveType
          }
          leaveFrom
          leaveTill
          totalDays
          halfDay
          reason
          status
          lastUpdate
          teamApproval
          teamleaderId
          hrApproval
          user {
            id
            empid
            username
            firstName
          }
        }
      }`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,

          variables: { id: empid },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const ManagerRequestList = response.data.data.requestsForLeaveTeam;
      setManagerRequestList(ManagerRequestList);

      const userDetails = sessionStorage.getItem("user");
      const getDetails = JSON.parse(userDetails);
      setUserDetails({
        department: user?.department || getDetails.department || "",
        designation: user?.designation || getDetails.designation || "",
        employeeType: user?.employeeType || getDetails.employeeType || "",
      });
      setPageState({ ...pageState, loading: false, state: "success" });

    } catch (error) {
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  // const onManagerDetails = () => {
  //   if (tabValue === 1) {
  //     ManagerRquestDetails();
  //   }
  // };

  // const onEmployeeDetails = () => {
  //   if (tabValue === 2) {
  //     EmployeeLeaveDetails();
  //   }
  // };

  const handleNewLeave = () => {
    setLeaveShow(true);
    navigate("/leave-management/add-leaverequest");
    setleavedisplay(false);
  };
  const onLeaveListClick = (e) => {
    setleavedisplay(true);

    // if (e?.id) {
    //   // navigate(`/leave-management/add-leaverequest?id=${e?.id}`);
    //   navigate(`/leave-management/viewscreen?id=${e?.id}`);
    // }
    if (e?.id) {
      if (tabValue == "HR") {
        navigate(`/leave-management/leaveapproval?id=${e?.id}`);
        return;
      } else if (tabValue == "HRList") {
        navigate(`/leave-management/leaveapproval?id=${e?.id}`);
        return;
      } else if (tabValue == "Manager") {
        navigate(`/leave-management/leaveapproval?id=${e?.id}`);
        return;
      } else if (tabValue == "ManagerList") {
        navigate(`/leave-management/leaveapproval?id=${e?.id}`);
        return;
      } else {
        setLeaveShow(false);
        navigate(`/leave-management/add-leaverequest?id=${e?.id}`);
      }
      //   if(e.row.hrApproval == 'approved' && e.row.teamApproval == 'approved' && e.row.status == 'approved'){
      //     navigate(`/leave-management/viewscreen?id=${e?.id}`);
      //     return;
      // }
      // if (
      //   e.row.hrApproval == "Pending" &&
      //   e.row.teamApproval == "approved" &&
      //   e.row.status == "Pending"
      // ) {

      //   navigate(`/leave-management/viewscreen?id=${e?.id}`);
      //   return;
      // }

      if (
        e.row.hrApproval == "approved" &&
        e.row.teamApproval == "approved" &&
        e.row.status == "approved"
      ) {
        navigate(`/leave-management/viewscreen?id=${e?.id}`);
        return;
      }
      if (
        e.row.hrApproval == "Pending" &&
        e.row.teamApproval == "approved" &&
        e.row.status == "Pending"
      ) {
        navigate(`/leave-management/viewscreen?id=${e?.id}`);
        return;
      }
      if (
        e.row.hrApproval == "Pending" &&
        e.row.teamApproval == "rejected" &&
        e.row.status == "rejected"
      ) {

        navigate(`/leave-management/viewscreen?id=${e?.id}`);
        return;
      }
    }
  };

  const handleSetTabValue = (event, newValue) => {
    if (newValue == "HR") {
      setHRRoleLeave(true);
      // sessionStorage.removeItem('MainApp');

      sessionStorage.setItem("MainApp", JSON.stringify(newValue));

      SetHRLIST(newValue);
    } else if (newValue == "Manager") {
      setManagerLeave(true);
    } else if (newValue == "HRList") {
      sessionStorage.setItem("MainApp", JSON.stringify(newValue));
    }

    setTabValue(newValue);
  };
  const handleSetSubTabValue = (event, newValue) => {
    setSubTabValue(newValue);
  };

  const datahandelar = async () => {
    handleClearSelection();
    if (tabValue == "HR") {
      const query = `

      query GetAllLeaveDetails {

  leaveDetailsAll {

    id

    user {

      firstName
      username 
      lastName

    }

    leaveType {

      leaveType

    }

    leaveFrom

    leaveTill
    reason
    totalDays

    teamApproval

    hrApproval

    status

  }

}
 
  
`;

      // query GetAllLeaveDetails {

      //   leaveDetailsAll {

      //     id

      //     user {

      //       firstName

      //       lastName

      //     }

      //     leaveType {

      //       leaveType

      //     }

      //     leaveFrom

      //     leaveTill

      //     totalDays

      //     teamApproval

      //     hrApproval

      //     status

      //   }

      // }

      const encodedId = btoa(user?.id);

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            // variables: {
            //   id: TeamLeaderID[0]?.user.id,
            // },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        let leaveHRlist = response.data.data.leaveDetailsAll;
        setLeaveList(leaveHRlist);

        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error.response.data);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "HRList") {
      const query = `

      query TeamLeaveAll($id: String!) {
    requestsForLeaveTeamAll(id: $id) {

      id
      teamleaderId
      requestedOn
      leaveType{
      leaveType
      }
      leaveFrom
      leaveTill
      totalDays
      halfDay
      reason
      teamApproval
      hrApproval
      status
      user {
        id
        empid
        username
        firstName
      }
    }
  }
      
 `;

      //  query HrLeaveAll{
      //   requestsForLeaveAll{
      //   id
      //     user{
      //       email
      //       firstName
      //     }
      //     teamleaderId
      //     requestedOn
      //     leaveType{
      //       leaveType
      //     }
      //     leaveFrom
      //     leaveTill
      //     totalDays
      //     halfDay
      //     reason
      //     teamApproval
      //     hrApproval
      //     status
      //    }
      //   }

      const encodedId = btoa(user?.id);

      try {
        setPageState({ ...pageState, loading: true });
        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              //   id: "VXNlck5vZGU6" + "" + encodedId,
              id: teamleader.teamleader,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const regularizationList = response.data.data.requestsForLeaveTeamAll;
        setLeaveList(regularizationList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error.message);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "Manager") {
      const query = `
       query TeamLeavePending($id:String!){
  requestsForLeaveTeam(id:$id){
    id
    user{
      email
      firstName
    }
    teamleaderId
    requestedOn
    leaveType{
      leaveType
    }
    leaveFrom
    leaveTill
    totalDays
    halfDay
    reason
    teamApproval
    hrApproval
    status
   }
}
 
            `;

      const encodedId = btoa(user?.id);

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              //   id: "VXNlck5vZGU6" + "" + encodedId,
              id: TeamLeaderID[0]?.user.id,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // Extract department data from the response
        const regularizationList = response.data.data.requestsForLeaveTeam;
        setLeaveList(regularizationList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error.message);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "ManagerList") {
      const query = `
      query TeamLeaveAll($id:String!){
  requestsForLeaveTeamAll(id:$id){
    id
    user{
      email
      firstName
    }
    teamleaderId
    requestedOn
    leaveType{
      leaveType
    }
    leaveFrom
    leaveTill
    totalDays
    halfDay
    reason
    teamApproval
    hrApproval
    status
   }
}
 
            `;

      const encodedId = btoa(user?.id);

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              //   id: "VXNlck5vZGU6" + "" + encodedId,
              id: TeamLeaderID[0]?.user.id,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // Extract department data from the response
        const regularizationList = response.data.data.requestsForLeaveTeamAll;
        setLeaveList(regularizationList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error.message);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else {
      const query = `query leaveTrackDetails($employeeid: String!) {
    leaveRequestsByMe(id: $employeeid) {
      id
      user {
        id
        empid
        firstName
        username
      }
      requestedOn
      leaveType{
      id
        leaveType
      }
      leaveFrom
      leaveTill
      reason
      totalDays
      teamApproval
      hrApproval
      status
    }
  }`;
      const encodedId = btoa(user?.id);

      try {
        setPageState({ ...pageState, loading: true });


        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: { employeeid: "VXNlck5vZGU6" + "" + encodedId },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const leaveList = response.data.data.leaveRequestsByMe;

        setLeaveList(leaveList);
        // Extract department data from the response
        // const regularizationList = response.data.data.regularizationRequestByMe;

        // setRegularizationList(regularizationList || []);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error.response.data);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    }
  };

  return (
    <DashboardLayout>
      <div>
        {/* Show loading spinner while fetching data */}
        {/* {pageState.loading && (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // Full viewport height to center vertically
        width: "100%", // Full width
        position: "fixed", // Ensure it overlays the content
        top: 0,
        left: 0,
         backgroundColor: "rgba(255, 255, 255, 0.8)", // Optional: Add a semi-transparent background
        zIndex: 9999, // Ensure it's above other elements
      }}
    >
      <CircularProgress />
    </div> // Correctly closes the spinner container
  )} */}
      </div>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Leave list
                </MaterialTypography>
                {/* <MaterialTypography variant="caption" color="text">
                                List of leave that you can get details of leave.
                            </MaterialTypography> */}
              </Stack>

              <MaterialBox
                display="flex"
                justifyContent={{ md: "flex-end" }}
                alignItems="center"
                width="60%"
              >
                <MaterialBox width="80%">
                  <AppBar position="static">
                    <Tabs
                      orientation={tabsOrientation}
                      value={tabValue}
                      onChange={handleSetTabValue}
                      sx={{
                        backgroundColor: "#f8f9fa", // Light background
                        borderRadius: "12px",
                        padding: "5px",
                      }}
                    >
                      {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            item.component === "HrApproval" && item.can_access
                        ) && <Tab label="HR List" value="HR"   sx={{
                          transition: "0.3s",
                          "&:hover": {
                            backgroundColor: "#e5e8ec",
                            color: "#fff",
                            borderRadius: "8px",
                          },
                        }}/>}
                      {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            (item.component === "HrApproval" || item.component === "ManagerApproval") && item.can_access
                        ) && <Tab
                        label="Team List"
                        value="HRList"
                        sx={{
                          color: "#2c5da8",
                          transition: "0.3s",
                          "&:hover": {
                            backgroundColor: "#e5e8ec",
                            color: "#1348a5",
                            borderRadius: "8px",
                          },
                        }}
                        />}
                      <Tab
                        label="My List"
                        value="Employee"
                        sx={{
                          color: "#2c5da8",
                          transition: "0.3s",
                          "&:hover": {
                            backgroundColor: "#e5e8ec",
                            color: "#1348a5",
                            borderRadius: "8px",
                          },
                        }}
                        />
                    </Tabs>
                  </AppBar>
                </MaterialBox>
              </MaterialBox>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddLeave" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewLeave()}
                  >
                    Apply Leave
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          // rows={
          //   tabValue === 0 // tabValue is for the parent tab
          //     ? leaveListTable.rows
          //     : tabValue === 1 // tabValue is for the parent tab
          //     ? managerDetails
          //     : tabValue === 2
          //     ? managerDetails
          //     : null
          // }
          rows={leaveListTable.rows}
          columns={leaveListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onLeaveListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No leave found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any leave details. Click on the "Add
                  leave" button to start adding leave details.
                </MaterialTypography>
              </Stack>
            ),
          }}
          subTab={
            (userDetails?.designation === "PEOPLE MANAGER" ||
              userDetails?.designation === "Project Manager") && (
              <AppBar position="static">
                <Tabs
                  orientation={tabsOrientation}
                  value={subTabValue}
                  onChange={handleSetSubTabValue}
                  sx={{ backgroundColor: "transparent" }}
                >
                  {/* {tabs.map(tab => (
                                    <Tab label={tab.name} icon={<StyledBadge badgeContent={tab.count} color="error" />} iconPosition="end"
                                    />
                                ))} */}
                  <Tab label="All" />
                  <Tab label="Pending Request" />
                  <Tab label="Approved" />
                  <Tab label="Rejected" />
                </Tabs>
              </AppBar>
            )
          }
        />
      </Card>
    </DashboardLayout>
  );
};

export default LeaveManagement;
